<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 8.33325H15" stroke="#D30101" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M24.9948 15V20H31.6615L19.9948 31.6667L8.32812 20H14.9948V15H24.9948Z" stroke="#D30101" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>